import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import InstallPWA from './components/InstallPWA';
import Home from './pages/Home';
import Particuliers from './pages/Particuliers';
import Professionnels from './pages/Professionnels';
import Contact from './pages/Contact';
import ClientMystere from './pages/ClientMystere';
import ClientMystereTarifs from './pages/ClientMystereTarifs';
import Formations from './pages/Formations';
import Conseils from './pages/Conseils';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalNotice from './pages/LegalNotice';

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Navigation />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/particuliers" element={<Particuliers />} />
              <Route path="/professionnels" element={<Professionnels />} />
              <Route path="/professionnels/conseils" element={<Conseils />} />
              <Route path="/professionnels/formations" element={<Formations />} />
              <Route path="/professionnels/client-mystere" element={<ClientMystere />} />
              <Route path="/professionnels/client-mystere/tarifs" element={<ClientMystereTarifs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
              <Route path="/mentions-legales" element={<LegalNotice />} />
            </Routes>
          </main>
          <Footer />
          <InstallPWA />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
